import React, { type JSX } from 'react';
import query from './EkonomiskAnalysHasPeriodiseradBudgetQuery.gql';
import {
  EkonomiskAnalysHasPeriodiseradBudgetQueryVariables as IVariables,
  EkonomiskAnalysHasPeriodiseradBudgetQuery as IData,
} from './_QueryTypes/EkonomiskAnalysHasPeriodiseradBudgetQuery';
import { Query } from '@apollo/client/react/components';

interface IProps {
  year?: number;
  databaseName: string;
  children: (isPeriodiserad: boolean) => JSX.Element;
}

const EkonomiskAnalysHasPeriodiseradBudgetQuery: React.FunctionComponent<
  IProps
> = props => {
  const skip = props.year === undefined;
  return (
    <Query<IData, IVariables>
      skip={skip}
      query={query}
      variables={{ year: props.year || 0, databaseName: props.databaseName }}
      fetchPolicy={'cache-and-network'}
    >
      {({ loading, error, data }) => {
        if (loading || error || !data) {
          return props.children(false);
        } else {
          return props.children(data.ekanalyshasperiodiseradbudget);
        }
      }}
    </Query>
  );
};

export default EkonomiskAnalysHasPeriodiseradBudgetQuery;
